import React, { useState, useEffect } from 'react';
import { Button, Typography } from 'antd';
import moment from 'moment';

const Stopwatch = ({ onLogTime }) => {
    const [isActive, setIsActive] = useState(false);
    const [isPaused, setIsPaused] = useState(true);
    const [time, setTime] = useState(0);

    useEffect(() => {
        let interval = null;
        if (isActive && !isPaused) {
            interval = setInterval(() => {
                setTime((time) => time + 10);
            }, 10);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isActive, isPaused]);

    const handleStart = () => {
        setIsActive(true);
        setIsPaused(false);
    };

    const handlePause = () => {
        setIsPaused(!isPaused);
    };

    const handleReset = () => {
        setIsActive(false);
        setTime(0);
    };

    const handleLog = () => {
        onLogTime(time);
    };

    return (
        <div>
            <Typography.Title level={4}>
                {moment.utc(time).format("HH:mm:ss.SSS")}
            </Typography.Title>
            <Button onClick={handleStart} disabled={isActive && !isPaused}>Start</Button>
            <Button onClick={handlePause} disabled={!isActive}>{isPaused ? 'Resume' : 'Pause'}</Button>
            <Button onClick={handleReset} disabled={!isActive}>Reset</Button>
            <Button onClick={handleLog} type="primary" disabled={!isActive}>Log Time</Button>
        </div>
    );
};

export default Stopwatch;